import { AuthorizeNetProfileParamsDto } from '../dtos/authorize-net-profile.dto';
import { AuthorizeNetProfileParams } from '../models/authorize-net-profile';

/**
 * To authorize net profile params dto.
 * @param {AuthorizeNetProfileParams} params Params model.
 * @returns {AuthorizeNetProfileParamsDto}
 */
function toDto(params) {
  return new AuthorizeNetProfileParamsDto({ group_admin_id: params.groupAdminId ?? undefined });
}

export const authorizeNetProfileParamsMapper = {
  toDto,
};
